<template>
  <div style="margin-top: 20px; padding: 11px;">
    <!-- Loading State -->
    <div v-if="loading" class="loading-container">
      <p>Veriler yükleniyor...</p>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="error-container">
      <p class="error-message">{{ error }}</p>
      <button @click="getPersonalData" class="retry-button">Tekrar Dene</button>
    </div>

    <!-- Data Display -->
    <div v-else>
      <!-- Kişisel Bilgileri - Her zaman görünsün -->
      <div class="personal-details-container">
        <div class="personal-details-header">
          <h1>Kişisel Bilgileri</h1>
          <span @click="togglePersonalInfo" class="arrow-icon" :class="{'open': showPersonalInfo}">&#x25BC;</span>
          <hr>
        </div>

        <div v-if="showPersonalInfo">
          <div class="table-responsive">
            <table>
              <tbody>
              <tr>
                <th>Personel Adı</th>
                <td>{{ personalInfo ? personalInfo.name || '' : '' }}</td>
              </tr>
              <tr>
                <th>Çalışma Durumu</th>
                <td>{{ personalInfo && personalInfo.workType !== null && personalInfo.workType !== undefined ? (personalInfo.workType ? 'Tam Zamanlı' : 'Yarı Zamanlı') : '' }}</td>
              </tr>
              <tr>
                <th>Emeklilik Durumu</th>
                <td>{{ personalInfo && personalInfo.workOrRetired !== null && personalInfo.workOrRetired !== undefined ? (personalInfo.workOrRetired ? 'Emekli Değil' : 'Emekli') : '' }}</td>
              </tr>
              <tr>
                <th>Rolü</th>
                <td>{{ personalInfo && personalInfo.role ? personalInfo.role.roleName || '' : '' }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Sözleşme Bilgileri - Her zaman görünsün -->
      <div class="personal-details-container">
        <div class="personal-details-header">
          <h1>Sözleşme Bilgileri</h1>
          <span @click="toggleContractInfo" class="arrow-icon" :class="{'open': showContractInfo}">&#x25BC;</span>
          <hr>
        </div>

        <div v-if="showContractInfo">
          <div class="table-responsive">
            <!-- Sözleşme verisi var mı kontrol et -->
            <div v-if="hasContractData">
              <!-- Aktif Sözleşmeler -->
              <div v-if="activeContracts.length > 0">
                <h4>Aktif Sözleşmeler</h4>
                <div class="table-responsive-wrapper">
                  <table class="profitability-table">
                  <thead>
                  <tr>
                    <th>Firma Adı</th>
                    <th>Sözleşme Adı</th>
                      <th>Sözleşme No</th>
                      <th>Söz. Baş. Tarihi</th>
                      <th>Söz. Yen. Tarihi</th>
                      <th>Per. Proje Başlama Tarihi</th>
                      <th>Per. Proje Ayrılma Tarihi</th>
                      <th>Sözleşme Süresi (Ay)</th>
                      <th>Sözleşme Bedeli</th>
                      <th>Saatlik Brüt Tutar</th>
                      <th>Aylık Brüt Tutar</th>
                      <th>Çalışılan Saat</th>
                      <th>Sigorta Günü</th>
                      <th>SGK İşveren Payı</th>
                      <th>SGK Oranı</th>
                      <th>Yakıt Gideri</th>
                      <th>Seyahat Gideri</th>
                      <th>Yemek Gideri</th>
                      <th>Araç Kira Gideri</th>
                      <th>Diğer Giderler</th>
                      <th>Yedek Hizmet</th>
                      <th>Kıdem Yükü</th>
                      <th>Kıdem Taz. Tutarı</th>
                      <th>Toplam Masraflar</th>
                      <th>Toplam Maliyet</th>
                      <th>Fatura Tutarı</th>
                      <th>Yönetim Gid. Öncesi Kâr/Zarar</th>
                      <th>Yönetim Gid. Öncesi Kar Oranı (%)</th>
                      <th>Yönetim Gider Payı (TL)</th>
                      <th>Yönetim Gider Payı (%)</th>
                      <th>Yönetim Gid. Sonrası Kâr/Zarar</th>
                      <th>Yönetim Gid. Sonrası Kar Oranı (%)</th>
                      <th>Aktif Durum</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="contract in activeContracts"
                      :key="contract.contract_id">
                      <td>{{ contract.company_name || 'Bilgi Yok' }}</td>
                      <td>{{ contract.contract_name || 'Bilgi Yok' }}</td>
                      <td>{{ contract.contract_number || 'Bilgi Yok' }}</td>
                    <td>{{ formatDate(contract.contract_date) }}</td>
                    <td>{{ formatDate(contract.renewal_contract_date) }}</td>
                    <td>{{ formatDate(contract.personal_start_date) }}</td>
                      <td>{{ formatDate(contract.personal_end_date, true) }}</td>
                      <td>{{ contract.contracttime || 'Bilgi Yok' }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.contract_price) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.hours_net_amount) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.monthGrossAmount) }}</td>
                      <td style="text-align: right;">{{ formatHours(contract.worked_hours) }}</td>
                      <td style="text-align: right;">{{ contract.insuranceDay || '0' }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.sgkEmployerShare) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.sgkrate) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.fuelexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.travelexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.foodexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.carrentexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.otherexpenses) }}</td>
                      <td>{{ formatBoolean(contract.replacementservice) }}</td>
                      <td>{{ formatBoolean(contract.seniorityburden) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.severanceAmount) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.totalOfExpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.totalCost) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.invoiceAmount) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.profitBeforeAdministrativeExpenses) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.profitBeforeManagementRate) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.managementExpenseRateTL) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.projectProfitabilityManagementExpenseRate) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.profitAfterAdministrativeExpenses) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.profitAfterManagementRate) }}</td>
                      <td>{{ formatBoolean(contract.isActive) }}</td>
                  </tr>
                  </tbody>
                </table>
                </div>
              </div>

              <!-- Pasif Sözleşmeler -->
              <div v-if="inactiveContracts.length > 0" class="inactive-contracts-section">
                <h4>Pasif Sözleşmeler</h4>
                <div class="table-responsive-wrapper">
                  <table class="profitability-table">
                  <thead>
                  <tr>
                    <th>Firma Adı</th>
                    <th>Sözleşme Adı</th>
                      <th>Sözleşme No</th>
                      <th>Söz. Baş. Tarihi</th>
                      <th>Söz. Yen. Tarihi</th>
                      <th>Per. Proje Başlama Tarihi</th>
                      <th>Per. Proje Ayrılma Tarihi</th>
                      <th>Sözleşme Süresi (Ay)</th>
                      <th>Sözleşme Bedeli</th>
                      <th>Saatlik Brüt Tutar</th>
                      <th>Aylık Brüt Tutar</th>
                      <th>Çalışılan Saat</th>
                      <th>Sigorta Günü</th>
                      <th>SGK İşveren Payı</th>
                      <th>SGK Oranı</th>
                      <th>Yakıt Gideri</th>
                      <th>Seyahat Gideri</th>
                      <th>Yemek Gideri</th>
                      <th>Araç Kira Gideri</th>
                      <th>Diğer Giderler</th>
                      <th>Yedek Hizmet</th>
                      <th>Kıdem Yükü</th>
                      <th>Kıdem Taz. Tutarı</th>
                      <th>Toplam Masraflar</th>
                      <th>Toplam Maliyet</th>
                      <th>Fatura Tutarı</th>
                      <th>Yönetim Gid. Öncesi Kâr/Zarar</th>
                      <th>Yönetim Gid. Öncesi Kar Oranı (%)</th>
                      <th>Yönetim Gider Payı (TL)</th>
                      <th>Yönetim Gider Payı (%)</th>
                      <th>Yönetim Gid. Sonrası Kâr/Zarar</th>
                      <th>Yönetim Gid. Sonrası Kar Oranı (%)</th>
                      <th>Aktif Durum</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="contract in inactiveContracts"
                      :key="contract.contract_id"
                      class="expired-contract">
                      <td>{{ contract.company_name || 'Bilgi Yok' }}</td>
                      <td>{{ contract.contract_name || 'Bilgi Yok' }}</td>
                      <td>{{ contract.contract_number || 'Bilgi Yok' }}</td>
                    <td>{{ formatDate(contract.contract_date) }}</td>
                    <td>{{ formatDate(contract.renewal_contract_date) }}</td>
                    <td>{{ formatDate(contract.personal_start_date) }}</td>
                      <td>{{ formatDate(contract.personal_end_date, true) }}</td>
                      <td>{{ contract.contracttime || 'Bilgi Yok' }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.contract_price) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.hours_net_amount) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.monthGrossAmount) }}</td>
                      <td style="text-align: right;">{{ formatHours(contract.worked_hours) }}</td>
                      <td style="text-align: right;">{{ contract.insuranceDay || '0' }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.sgkEmployerShare) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.sgkrate) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.fuelexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.travelexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.foodexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.carrentexpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.otherexpenses) }}</td>
                      <td>{{ formatBoolean(contract.replacementservice) }}</td>
                      <td>{{ formatBoolean(contract.seniorityburden) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.severanceAmount) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.totalOfExpenses) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.totalCost) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.invoiceAmount) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.profitBeforeAdministrativeExpenses) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.profitBeforeManagementRate) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.managementExpenseRateTL) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.projectProfitabilityManagementExpenseRate) }}</td>
                      <td style="text-align: right;">{{ formatCurrency(contract.profitAfterAdministrativeExpenses) }}</td>
                      <td style="text-align: right;">{{ formatPercentage(contract.profitAfterManagementRate) }}</td>
                      <td>{{ formatBoolean(contract.isActive) }}</td>
                  </tr>
                  </tbody>
                </table>
                </div>
              </div>


              <!-- Hem aktif hem pasif sözleşme yoksa -->
              <div v-if="activeContracts.length === 0 && inactiveContracts.length === 0" class="no-data-message">
                <p>Bu personel için sözleşme bilgisi bulunamadı.</p>
                <p>Personel henüz bir sözleşmeye atanmamış olabilir.</p>
              </div>
            </div>

            <!-- Sözleşme verisi yoksa -->
            <div v-else class="no-data-message">
              <p>Bu personel için sözleşme bilgisi yoktur.</p>
              <p>Personel henüz bir sözleşmeye atanmamış olabilir.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import apiClient from "@/axios";

export default {
  name: "PersonalDetail",
  data() {
    return {
      personalData: [],
      personalInfo: null,
      activeContractsData: [],
      inactiveContractsData: [],
      showPersonalInfo: true,
      showContractInfo: true,
      loading: false,
      error: null,
    };
  },
  created() {
    this.getPersonalData();
  },
  computed: {
    hasPersonalData() {
      return Array.isArray(this.personalData) && this.personalData.length > 0;
    },
    hasContractData() {
      // MongoDB'den gelen sözleşme verisi var mı kontrol et
      return Array.isArray(this.personalData) &&
          this.personalData.length > 0 &&
          this.personalData.some(item =>
              item.contractId !== null &&
              item.contractId !== undefined &&
              item.contractName !== null &&
              item.contractName !== undefined &&
              item.companyName !== null &&
              item.companyName !== undefined
          );
    },
    activeContracts() {
      // MongoDB'den gelen aktif sözleşmeleri kullan
      if (!Array.isArray(this.personalData) || this.personalData.length === 0) return [];

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Bugünün başlangıcı

      return this.personalData.filter(contract => {
        // Temel kontroller
        if (contract.contractId === null || contract.contractId === undefined ||
            contract.contractName === null || contract.contractName === undefined) {
          return false;
        }

        // Sözleşme durumu 'Aktif' olmalı
        if (contract.contract_status !== 'Aktif') {
          return false;
        }

        // deletedAt (Personel Bitiş Tarihi) kontrolü
        const deletedAt = contract.deletedAt ? new Date(contract.deletedAt) : null;

        // Sadece deletedAt yoksa (null) veya ileri bir tarihse aktif bölümde göster
        if (!deletedAt || deletedAt > today) {
          return true;
        }

        return false;
      }).map(contract => {
        const deletedAt = contract.deletedAt ? new Date(contract.deletedAt) : null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Durum belirleme
        let status = 'Aktif';
        if (deletedAt && deletedAt > today) {
          status = 'Gelecekte İşten Çıkacak';
        }

        return {
          contract_id: contract.contractId,
          contract_name: contract.contractName,
          contract_number: contract.contractNumber,
          contract_date: contract.contractDate,
          renewal_contract_date: contract.renewalContractDate,
          contract_price: contract.contractPrice || contract.invoiceAmount || 0,
          personal_start_date: contract.personalStartDate,
          personal_end_date: contract.deletedAt,
          worked_hours: contract.workedhours || 0,
          hours_net_amount: contract.hoursnetamount || 0,
          month_net_amount: contract.monthGrossAmount || 0,
          contract_status: status,
          company_name: contract.companyName,
          // Proje karlılık verileri (API'den gelen)
          contracttime: contract.contracttime || null,
          monthGrossAmount: contract.monthGrossAmount,
          insuranceDay: contract.insuranceDay,
          sgkEmployerShare: contract.sgkEmployerShare,
          sgkrate: contract.sgkrate || null,
          fuelexpenses: contract.fuelexpenses || 0,
          travelexpenses: contract.travelexpenses || 0,
          foodexpenses: contract.foodexpenses || 0,
          carrentexpenses: contract.carrentexpenses || 0,
          otherexpenses: contract.otherexpenses || 0,
          replacementservice: contract.replacementservice || false,
          seniorityburden: contract.seniorityburden || false,
          severanceAmount: contract.severanceAmount || 0,
          totalOfExpenses: contract.totalOfExpenses || 0,
          totalCost: contract.totalCost || 0,
          invoiceAmount: contract.invoiceAmount || 0,
          profitBeforeAdministrativeExpenses: contract.profitBeforeAdministrativeExpenses || 0,
          profitBeforeManagementRate: contract.profitBeforeManagementRate || null,
          managementExpenseRateTL: contract.managementExpenseRateTL || 0,
          projectProfitabilityManagementExpenseRate: contract.managementExpenseRate || contract.shareOfManagementExpenses || null,
          profitAfterAdministrativeExpenses: contract.profitAfterAdministrativeExpenses || 0,
          profitAfterManagementRate: contract.profitAfterManagementRate || null,
          isActive: contract.isActive !== undefined ? contract.isActive : true
        };
      });
    },

    inactiveContracts() {
      // MongoDB'den gelen pasif sözleşmeleri kullan
      if (!Array.isArray(this.personalData) || this.personalData.length === 0) return [];

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Bugünün başlangıcı

      return this.personalData.filter(contract => {
        // Temel kontroller
        if (contract.contractId === null || contract.contractId === undefined ||
            contract.contractName === null || contract.contractName === undefined) {
          return false;
        }

        // Sözleşme durumu 'Pasif' olanlar
        if (contract.contract_status === 'Pasif') {
          return true;
        }

        // Sözleşme durumu 'Aktif' olan ama deletedAt (Personel Bitiş Tarihi) geçmiş olanlar
        if (contract.contract_status === 'Aktif') {
          const deletedAt = contract.deletedAt ? new Date(contract.deletedAt) : null;
          if (deletedAt && deletedAt <= today) {
            return true;
          }
        }

        return false;
      }).map(contract => {
        const deletedAt = contract.deletedAt ? new Date(contract.deletedAt) : null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Durum belirleme
        let status = 'Pasif';
        if (contract.contract_status === 'Aktif' && deletedAt && deletedAt <= today) {
          status = 'Süresi Dolmuş';
        }

        return {
          contract_id: contract.contractId,
          contract_name: contract.contractName,
          contract_number: contract.contractNumber,
          contract_date: contract.contractDate,
          renewal_contract_date: contract.renewalContractDate,
          contract_price: contract.contractPrice || contract.invoiceAmount || 0,
          personal_start_date: contract.personalStartDate,
          personal_end_date: contract.deletedAt,
          worked_hours: contract.workedhours || 0,
          hours_net_amount: contract.hoursnetamount || 0,
          month_net_amount: contract.monthGrossAmount || 0,
          contract_status: status,
          company_name: contract.companyName,
          // Proje karlılık verileri (API'den gelen)
          contracttime: contract.contracttime || null,
          monthGrossAmount: contract.monthGrossAmount,
          insuranceDay: contract.insuranceDay,
          sgkEmployerShare: contract.sgkEmployerShare,
          sgkrate: contract.sgkrate || null,
          fuelexpenses: contract.fuelexpenses || 0,
          travelexpenses: contract.travelexpenses || 0,
          foodexpenses: contract.foodexpenses || 0,
          carrentexpenses: contract.carrentexpenses || 0,
          otherexpenses: contract.otherexpenses || 0,
          replacementservice: contract.replacementservice || false,
          seniorityburden: contract.seniorityburden || false,
          severanceAmount: contract.severanceAmount || 0,
          totalOfExpenses: contract.totalOfExpenses || 0,
          totalCost: contract.totalCost || 0,
          invoiceAmount: contract.invoiceAmount || 0,
          profitBeforeAdministrativeExpenses: contract.profitBeforeAdministrativeExpenses || 0,
          profitBeforeManagementRate: contract.profitBeforeManagementRate || null,
          managementExpenseRateTL: contract.managementExpenseRateTL || 0,
          projectProfitabilityManagementExpenseRate: contract.managementExpenseRate || contract.shareOfManagementExpenses || null,
          profitAfterAdministrativeExpenses: contract.profitAfterAdministrativeExpenses || 0,
          profitAfterManagementRate: contract.profitAfterManagementRate || null,
          isActive: contract.isActive !== undefined ? contract.isActive : false
        };
      });
    },
  },
  methods: {
    getPersonalData() {
      const personalId = this.$route.params.id;
      console.log('Fetching data for personalId:', personalId);

      this.loading = true;
      this.error = null;

      // Önce personel bilgilerini çek
      apiClient.get(`personal/${personalId}`).then((personalRes) => {
        console.log('Personel bilgileri:', personalRes.data);
        this.personalInfo = personalRes.data;

        // MongoDB'den tüm sözleşme bilgilerini çek (aktif + pasif)
        return apiClient.get(`personal/${personalId}/contracts`);
      }).then((contractsRes) => {
        console.log('Sözleşme bilgileri (MongoDB):', contractsRes.data);

        if (Array.isArray(contractsRes.data)) {
          this.personalData = contractsRes.data;
          console.log('Contract data set edildi:', this.personalData);
          console.log('Has contract data:', this.hasContractData);
          console.log('Active contracts count:', this.activeContracts.length);
          console.log('Inactive contracts count:', this.inactiveContracts.length);

          // Debug: deletedAt değerlerini kontrol et
          this.personalData.forEach((contract, index) => {
            const deletedAtDate = contract.deletedAt ? new Date(contract.deletedAt) : null;
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            console.log(`Contract ${index}:`, {
              contractId: contract.contractId,
              contractName: contract.contractName,
              contract_status: contract.contract_status,
              deletedAt: contract.deletedAt,
              deletedAtFormatted: deletedAtDate ? deletedAtDate.toLocaleDateString('tr-TR') : 'null',
              today: today.toLocaleDateString('tr-TR'),
              isFuture: deletedAtDate ? deletedAtDate > today : false,
              isPast: deletedAtDate ? deletedAtDate <= today : false
            });
          });
        } else {
          console.error('Sözleşme verisi array değil:', contractsRes.data);
          this.personalData = [];
        }

        this.loading = false;
      }).catch((error) => {
        console.error("Veri alınırken hata oluştu:", error);
        console.error("Error details:", error.response?.data);
        this.error = "Veri alınırken hata oluştu: " + (error.response?.data || error.message);
        this.personalData = [];
        this.loading = false;
      });
    },
    formatDate(timestamp, allowNull = false) {
      if (!timestamp) return allowNull ? "" : "Bilgi Yok";
      return new Date(timestamp).toLocaleDateString("tr-TR", {
        year: 'numeric', month: '2-digit', day: '2-digit'
      });
    },

    formatCurrency(value) {
      if (value === null || typeof value === 'undefined') return "₺0,00";
      const num = parseFloat(value);
      if (isNaN(num)) return "₺0,00";
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(num);
    },
    formatBoolean(value) {
      if (value === null || typeof value === 'undefined') return "Bilgi Yok";
      if (value === true) return "Evet";
      if (value === false) return "Hayır";
      return "Geçersiz Değer";
    },
    formatPercentage(value) {
      if (value === null || typeof value === 'undefined' || value === '') return "%0.00";
      const num = parseFloat(value);
      if (isNaN(num)) return "%0.00";
      return `%${num.toFixed(2)}`;
    },
    formatHours(value) {
      if (value === null || typeof value === 'undefined') return "0.00";
      const num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toFixed(2);
    },

    togglePersonalInfo() {
      this.showPersonalInfo = !this.showPersonalInfo;
    },

    toggleContractInfo() {
      this.showContractInfo = !this.showContractInfo;
    },

    getPersonalField(fieldName, defaultValue) {
      if (this.hasPersonalData && this.personalData[0] && this.personalData[0][fieldName]) {
        return this.personalData[0][fieldName];
      }
      return this.personalData[0] ? this.personalData[0][fieldName] || '' : '';
    },

    getWorkType() {
      if (this.hasPersonalData && this.personalData[0] && this.personalData[0].worktype !== null && this.personalData[0].worktype !== undefined) {
        return this.personalData[0].worktype ? 'Tam Zamanlı' : 'Yarı Zamanlı';
      }
      return this.personalData[0] ? (this.personalData[0].worktype ? 'Tam Zamanlı' : 'Yarı Zamanlı') : '';
    },

    getWorkOrRetired() {
      if (this.hasPersonalData && this.personalData[0] && this.personalData[0].workorretired !== null && this.personalData[0].workorretired !== undefined) {
        return this.personalData[0].workorretired ? 'Emekli Değil' : 'Emekli';
      }
      return this.personalData[0] ? (this.personalData[0].workorretired ? 'Emekli Değil' : 'Emekli') : '';
    },

    getStatusClass(status) {
      if (status === 'Aktif') {
        return 'status-active';
      } else if (status === 'Gelecekte İşten Çıkacak') {
        return 'status-future';
      } else if (status === 'Pasif') {
        return 'status-passive';
      } else if (status === 'Süresi Dolmuş') {
        return 'status-expired';
      }
      return ''; // Default class
    }
  },
};
</script>

<style scoped>
.personal-details-container {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.personal-details-header {
  text-align: left;
  margin-bottom: 20px;
}

.personal-details-header h1 {
  font-size: 24px;
  color: #333;
  display: inline-block;
}

.arrow-icon {
  float: right;
  cursor: pointer;
  font-size: 24px;
  transition: transform 0.2s ease;
  color: #3498db;
}

.arrow-icon.open {
  transform: rotate(180deg);
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

th, td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
  width: 30%;
}

td {
  color: #666;
}

tr:hover {
  background-color: #f5f5f5;
}

.expired-contract {
  background-color: #ffe6e6;
  color: #cc0000;
}

.expired-contract:hover {
  background-color: #ffcccc;
}

.table-responsive {
  overflow-x: auto;
}

h4 {
  color: #333;
  margin-bottom: 15px;
  border-bottom: 2px solid #3498db;
  padding-bottom: 5px;
}

.loading-container {
  text-align: center;
  padding: 40px;
  color: #666;
}

.error-container {
  text-align: center;
  padding: 40px;
  background-color: #ffe6e6;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  margin: 20px 0;
}

.error-message {
  color: #cc0000;
  margin-bottom: 20px;
  font-size: 16px;
}

.retry-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.retry-button:hover {
  background-color: #2980b9;
}

.no-data-message {
  text-align: center;
  padding: 40px;
  color: #666;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin: 20px 0;
  border: 2px dashed #dee2e6;
}

.no-data-message p {
  margin: 10px 0;
  font-size: 16px;
}

.no-data-message p:first-child {
  font-weight: bold;
  color: #495057;
  font-size: 18px;
}

.status-active {
  background-color: #e0f2f7;
  color: #20a0ff;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.status-future {
  background-color: #fff3cd;
  color: #856404;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.status-passive {
  background-color: #ffe6e6;
  color: #cc0000;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.status-expired {
  background-color: #f8d7da;
  color: #721c24;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.inactive-contracts-section {
  margin-top: 30px;
}

.table-responsive-wrapper {
  overflow-x: auto;
  margin-top: 15px;
  -webkit-overflow-scrolling: touch;
}

.profitability-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  min-width: 100%;
}

.profitability-table th {
  background-color: #343a40;
  color: white;
  padding: 10px 8px;
  text-align: left;
  font-weight: bold;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
  border: 1px solid #dee2e6;
}

.profitability-table td {
  padding: 8px;
  border: 1px solid #dee2e6;
  white-space: nowrap;
  background-color: white;
}

.profitability-table tbody tr:hover {
  background-color: #f5f5f5;
}

.profitability-table tbody tr.expired-contract {
  background-color: #ffe6e6;
}

.profitability-table tbody tr.expired-contract:hover {
  background-color: #ffcccc;
}

.profitability-table tbody tr.expired-contract td {
  background-color: #ffe6e6;
}

.profitability-table tbody tr.expired-contract:hover td {
  background-color: #ffcccc;
}
</style>
